import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import CommandPalette from './CommandPalette';
import MobileNav from './MobileNav';
import { useAuth } from '../../context/AuthContext';

const AppLayout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);

  // Global keyboard shortcut for command palette
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Cmd/Ctrl + K to open command palette
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setCommandPaletteOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Don't show layout for unauthenticated pages or public portfolio pages
  if (!isAuthenticated || location.pathname.startsWith('/u/')) {
    return <>{children}</>;
  }

  return (
    <div className="app-layout">
      <Sidebar onOpenCommandPalette={() => setCommandPaletteOpen(true)} />
      
      <main className="app-main">
        <div className="app-content">
          {children}
        </div>
      </main>

      <MobileNav />

      <CommandPalette 
        isOpen={commandPaletteOpen} 
        onClose={() => setCommandPaletteOpen(false)} 
      />
    </div>
  );
};

export default AppLayout;
